import React from "react"
import { IRecentPurchaseDetails, IUserSurveyDetails, UserCard, UserCards } from "../userCardsTypes"
import { LunchSubscriptionCard } from "./components/LunchSubscriptionCard"
import { CheckInReminderCard } from "./components/CheckInReminderCard"
import { RecentPurchaseCard } from "./components/RecentPurchaseCard"
import { SummaryNumberCard } from "./components/SummaryNumberCard"
import { ExternalLinkCard } from "./components/ExternalLinkCard"
import { UserSurveyCard } from "./components/UserSurveyCard"
import { UserNewsCard } from "./components/UserNewsCard"

type UserCardFactoryProps = {
    card: UserCard
    showSurveyModal: (survey: IUserSurveyDetails["content"]) => void
    showDetailedReceiptModal: (order: IRecentPurchaseDetails) => void
}

export function UserCardFactory(props: UserCardFactoryProps) {
    const { card, showSurveyModal, showDetailedReceiptModal } = props

    switch (card.type) {
        case UserCards.CHECK_IN_REMINDER:
            return <CheckInReminderCard {...card.checkInReminderDetails} />
        case UserCards.RECENT_PURCHASE:
            return <RecentPurchaseCard card={card} showDetailedReceiptModal={showDetailedReceiptModal} />
        case UserCards.USER_SURVEY:
            return <UserSurveyCard card={card} showSurveyModal={showSurveyModal} />
        case UserCards.SUMMARY_NUMBER:
            return <SummaryNumberCard {...card.summaryNumberDetails} />
        case UserCards.LUNCH_SUBSCRIPTION:
            return <LunchSubscriptionCard {...card.lunchSubscriptionDetails} />
        case UserCards.EXTERNAL_LINK:
            return <ExternalLinkCard {...card.externalLinkDetails} />
        case UserCards.NEWS_ITEM:
            return <UserNewsCard {...card.newsItemDetails} />
        default:
            return null
    }
}
